angular.module('impactx.analytics').service('AppcuesService', [
    '$rootScope',
    'dataGen',
    '$window',
    AppcuesService]);

function AppcuesService($rootScope, dataGen, $window) {
    var self = this;
    self.userIsRegistered = false;

    self.registerHandlers = function () {
        if ($window.appcuesConfig) {
            $rootScope.$on('loginSuccess', function (event) {
                if (event && !self.userIsRegistered) {
                    self.userIsRegistered = true;
                    dataGen.getData({}, {}, '/appcues/user').then(function (response) {
                        var userData = impactX.isDefined(response, "data");
                        if (userData && userData.id) {

                            Appcues.identify(userData.id, {
                                userId: userData.id,
                                LetzterLogin: userData.lastLogin ? userData.lastLogin : null,
                                Bundeskunde: userData.isRegionalClient,
                                Rollen: userData.roles,
                                Benutzergruppen: userData.userGroups,
                                Zielgruppe: userData.targetGroup,
                                Organisation: userData.comId,
                                GV: userData.basicAgreementNumber
                            });
                        }
                    });
                }
            });
            $rootScope.$on('$locationChangeSuccess', function () {
                if ($window.Appcues) {
                    $window.Appcues.start();
                }
            });
            $rootScope.$on('logoutSuccess', function (event) {
                if (event) {
                    self.userIsRegistered = false;
                }
            })
        }
    };

    return {
        registerHandlers: self.registerHandlers
    };
}